import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-add-break',
    templateUrl: './add-break.component.html',
    styleUrls: ['./add-break.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddBreakComponent implements OnInit {

	@Input() task: any;
	@Input() project: any;
	@Input() chapter: any;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	formData: any = {
		'task_id': null,
		'value': null,
		'apply': false,
		'episode': null
	}
	title: string = 'day';

	submitForm() {
		this.loading = true;
		this._tS.addBreakTask(this.formData).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		);
	}

	close() {
		this.closeView.emit()
	}

	fillForm() {
		this.formData.task_id = this.task.id;
		if (this.chapter) {
			this.formData.value = this.chapter.real_break ? this.chapter.real_break : this.chapter.breake;
			this.formData.apply = this.chapter.apply_break ? true : false;
			this.formData.episode = this.chapter.text;
		} else {
			this.formData.value = this.task.breake;
			this.formData.episode = null;
			this.formData.apply = undefined;
		}
		if (this.task.task_duration_type_id == 2) {
			this.title = 'week';
			this.formData.value = this.formData.value / 7;
		}
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService) { }

	ngOnInit() {
		this.fillForm();
	}

}
